import api from '../../../services/api'
import buildQuery from 'odata-query'
import _ from 'lodash'

export const STANDARD_URL = '/standard'
export const STANDARDBY_URL = '/StandardStandBy'

/**
 * Retorna todos standards
 * @returns {Array}
 */
export function getAllStandard() {
    return api.get(STANDARD_URL);
}

/**
 * Retorna os standards por filtro
 * @param {*} queryParams 
 * @returns {Array}
 */
export function getByFilters(queryParams) {
    return api.get(`${STANDARD_URL}/odata${queryParams}`)
}

/**
 * Retorna a view
 * @param {int} id 
 * @returns {Array}
 */
export function fetchDataView(id) {
    return api.get(`${STANDARD_URL}/odata/` + buildQuery({
        filter: {
            id: parseInt(id)
        },
        expand: {
            steps: true,
            equipments: {
                expand: {
                    equipment: {
                        select: ['name', 'photo', 'type']
                    }
                }
            },
            structure: {
                select: ['name']
            }
        }
    }))
}

// Retorna a view
export function fetchDataById(id) {
    return api.get(`${STANDARD_URL}/odata/` + buildQuery({
        filter: {
            id: parseInt(id)
        },
        select: ['identifier']
    }))
}

/**
 * Retorna versões do Standard
 * @param {*} id 
 * @returns 
 */
export function fetchStandardVersions(id) {
    return api.get(`${STANDARDBY_URL}/odata/` + buildQuery({
        filter: {
            standardId: parseInt(id)
        },
        orderBy: 'Id desc',
        count: true,
        select: ['id', 'version', 'processSituation','standardType', 'standardId']
    }))
}

/**
 * @param {{
 *  identifier: string,
 *  path: string,
 *  odata: Partial<import('odata-query').QueryOptions<any>>
 * }} param01 
 * @returns 
 */
export function fetchStandardByIdentifier({ identifier, path, odata }) {
    if (path == 'idcard') {
        return api.get(`${path}/odata/` + buildQuery(_.defaultsDeep({
            filter: {
                identifier: identifier,
            },
            expand:
            {
                structure: {
                    select: ['name'],
                    expand: {
                        father: {
                            select: ['name']
                        }
                    }
                },
                product: true,
                defectCategory: true,
                defectType: true,
                user: {
                    select: ['name', 'sap']
                },
                steps: true
            }
            
        }, odata)))
    }
    else {
        return api.get(`${path}/odata/` + buildQuery(_.defaultsDeep({
            filter: {
                identifier: identifier,
            }
        }, odata)))
    }    
}

/**
 * Atualizar o autor do standard
 * @param {*} id 
 * @returns 
 */
 export function updateAuthor(id, userId) {
    return api.put(`${STANDARD_URL}/ChangeAuthor/`, {
        id,
        userId
    });
}

/**
 * Desativa o standard
 * @param {*} id 
 * @returns 
 */
 export function deactivate(id, deactivate = true) {
    return api.put(`${STANDARD_URL}/ChangeStatus/`, {
        id,
        'Status': deactivate ? 0 : 2
    });
}